export const SITE_URL = 'https://www.simulationslabs.com';

/**
 * Query params that identify a genuinely distinct, indexable page.
 * Everything else (utm_*, gclid, referral ids) is dropped so that a tracked
 * share link does not self-canonicalize into a duplicate URL.
 */
const INDEXABLE_PARAMS = ['page'];

/**
 * Absolute canonical URL for a path. Always on the www host, never with a
 * trailing slash (except the root), and carrying only indexable query params.
 */
export function canonicalUrl(pathname: string, search = ''): string {
  const path = pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;

  const incoming = new URLSearchParams(search);
  const kept = new URLSearchParams();
  for (const key of INDEXABLE_PARAMS) {
    const value = incoming.get(key);
    // `?page=1` is the same page as the unparameterized URL.
    if (value && value !== '1') kept.set(key, value);
  }

  const query = kept.toString();
  return `${SITE_URL}${path}${query ? `?${query}` : ''}`;
}

/** Canonical URL for a full request URL, e.g. inside a loader. */
export function canonicalUrlFromRequest(requestUrl: string): string {
  const url = new URL(requestUrl);
  return canonicalUrl(url.pathname, url.search);
}
